import tokenCookie from "@/modules/tokenCookie";
import apiResponse from "@/modules/apiResponse";
const {hasValidToken, getToken} = tokenCookie();
const {errorResponse} = apiResponse();
import axios from "axios";
import Apis from "@/urls/apis";

const state = {
    coachesAgentIntercity: {},
};
const getters = {
    getAllCoachesCounterAgentIntercity: (state) => state.coachesAgentIntercity.docs,
    getTotalCoachesCounterAgentIntercity: (state) => state.coachesAgentIntercity.totalDocs,
};
const actions = {
    async getAllCoachCounterAgentIntercity({commit}, payload) {
        if (await hasValidToken()) {
            const header = {
                'Authorization': 'Bearer ' + getToken()
            };

            return new Promise((resolve, reject) => {
                axios.get(Apis.COUNTERMAN_ALL_COACH_AGENT_INTERCITY, {
                    params: payload,
                    headers: header
                })
                    .then(({data, status}) => {
                        if (status === 200) {
                            commit("setAllCoachCounterAgentIntercity", data.coach)
                            resolve(data.coach)
                        }
                    })
                    .catch(error => {
                        reject(errorResponse(error))
                    });
            });
        }
    },
};
const mutations = {
    setAllCoachCounterAgentIntercity: (state, allCoaches) => (state.coachesAgentIntercity = allCoaches),
};

export default {
    state,
    getters,
    actions,
    mutations
};